<template>
  <LayoutGradient title="Página Proibida">
    <b-overlay :show="isLoading" class="m-3 mt-n10" no-center>
      <b-card  style="min-height: 100vh;">
        <b-form-group label="VNS">
          <v-select @input="i => setVns(i)" :options="vns" :reduce="option => option.id" label="name" />
        </b-form-group>

        <div class="row mt-3">
          <div class="col">
            <b-form-group label="Integração de Origem">
              <v-select
                  v-if="current"
                  :value="current.vns_integration_origin_id"
                  @input="i => setVnsAttribute('vns_integration_origin_id', i)"
                  :options="integrations"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Integração de Destino">
              <v-select
                  v-if="current"
                  :value="current.vns_integration_destination_id"
                  @input="i => setVnsAttribute('vns_integration_destination_id', i)"
                  :options="integrations"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <b-form-group label="Protocolo de Origem">
              <v-select
                  v-if="current"
                  :value="current.vns_protocol_origin_id"
                  :options="protocols"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="F. Arquivo de Origem">
              <v-select
                  v-if="current"
                  :value="current.vns_fileformat_origin_id"
                  :options="fileformats"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Protocolo de destino">
              <v-select
                  v-if="current"
                  :value="current.vns_protocol_destination_id"
                  :options="protocols"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="F. Arquivo de destino">
              <v-select
                  v-if="current"
                  :value="current.vns_fileformat_destination_id"
                  :options="fileformats"
                  :reduce="option => option.id"
                  label="name"
                  disabled="disabled"
              />
            </b-form-group>
          </div>
        </div>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import {mapActions, mapGetters} from "vuex";
import vSelect from 'vue-select'

export default {
  name: "EditTree",
  components: {
    LayoutGradient,
    vSelect
  },
  computed: {
    ...mapGetters({
      current: 'vns/current',
      vns: 'vns/all',
      vns_paginator: 'vns/pagination',
      vns_isLoading: 'vns/isLoading',
      integrations: 'integration/all',
      integration_isLoading: 'integration/isLoading',
      integration_current: 'integration/current',
      protocols: 'protocol/all',
      fileformats: 'fileformat/all'
    }),
    isLoading() {
      return this.vns_isLoading || this.integration_isLoading
    },
    integrationOrigin() {
      return this.integrations.find(i => i.id === this.current.vns_integration_origin_id)
    },
    integrationDestination() {
      return this.integrations.find(i => i.id === this.current.vns_integration_destination_id)
    }
  },
  methods: {
    ...mapActions([
      'vns/listTable',
      'vns/listOne',
      'integration/listAll',
      'integration/listOne'
    ]),
    async setVnsAttribute(key, value) {
      await this.$store.commit('vns/setCurrent', {...this.current, [key]: value})
    },
    async setVns(id_vns) {
      await this['vns/listOne'](id_vns)

      // ORIGIN
      if (!this.integrationOrigin) {
        await this['integration/listOne'](this.current.vns_integration_origin_id)
        await this.$store.commit('integration/setAll',
            [...this.integrations.filter(i => i.id !== this.vns_integration_origin_id), this.integration_current]
        )
      }

      // DESTINATION
      if (!this.integrationDestination) {
        await this['integration/listOne'](this.current.vns_integration_destination_id)
        await this.$store.commit('integration/setAll',
            [...this.integrations.filter(i => i.id !== this.vns_integration_destination_id), this.integration_current]
        )
      }

      // PROTOCOLS
      await this.$store.commit('protocol/setAll',
          this.integrations.reduce((acc,cur) => acc.find(a => a.id === cur.protocol.id) ? acc : [...acc, cur.protocol], [])
      )
      await this.setVnsAttribute('vns_protocol_origin_id', this.integrationOrigin.protocol.id)
      await this.setVnsAttribute('vns_protocol_destination_id', this.integrationDestination.protocol.id)

      // FILEFORMATS
      await this.$store.commit('fileformat/setAll',
          this.integrations.reduce((acc,cur) => acc.find(a => a.id === cur.file_format.id) ? acc : [...acc, cur.file_format], [])
      )
      await this.setVnsAttribute('vns_fileformat_origin_id', this.integrationOrigin.file_format.id)
      await this.setVnsAttribute('vns_fileformat_destination_id', this.integrationDestination.file_format.id)
    },
  },
  mounted() {
    this['vns/listTable'](this.vns_paginator)
  }
}
</script>
